import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export interface MostDiscussedInstrument {
  instrumentId: number;
  orderId: number;
  discussionNum: number;
  isin: string;
  wkn: string | number;
  displayName: string;
  link: string;
}

const WSO_BASE_URL = "https://www.wallstreet-online.de";
const WSO_API_TOKEN = import.meta.env.VITE_APP_WSO_API_TOKEN as string;

const getMostDiscussedInstruments = async (): Promise<
  MostDiscussedInstrument[]
> => {
  const { data } = await axios.get<MostDiscussedInstrument[]>(
    `${WSO_BASE_URL}/_rpc/json/export/community/getMostDiscussedInstruments`,
    { headers: { "X-API-Token": WSO_API_TOKEN } }
  );
  return data;
};

export const useMostDiscussedInstruments = ({ enabled = true } = {}) =>
  useQuery<MostDiscussedInstrument[], Error>({
    queryKey: ["wso", "mostDiscussedInstruments"],
    queryFn: getMostDiscussedInstruments,
    enabled,
  });
